import React, { useState } from 'react';
import {
  Modal,
} from 'antd';
import styles from './PublishAPILay.module.scss';
import FormLay from '../../../components/APIForm/index';
import APIRules from '../../../components/APIRules/index';

const PublishAPILay: React.FC = () => {
  const [showRule, setShowRule] = useState<boolean>(false);
  const handlerCloseModal = () => {
    setShowRule(false);
  };
  return (
    <div className={styles.publishLay}>
      <div className={`mid-font ${styles.mb20}`}>PUBLISH API</div>
      <div className={styles.subTitleOp}>
        Please refer to the {' '}
        {/* eslint-disable-next-line max-len */}
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <span onClick={() => {
          setShowRule(true);
        }}
        >
          User Guide
        </span>{' '}
        before publishing
      </div>
      <FormLay />
      {/* publishAPI rules */}
      <Modal
        title="User Guide for API PUBLISH"
        visible={showRule}
        onCancel={handlerCloseModal}
        footer={null}
        destroyOnClose
        width={800}
      >
        <APIRules handlerCloseModal={handlerCloseModal} />
      </Modal>
    </div>
  );
};

export default PublishAPILay;
